/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Text as TextType } from 'hocs/localization'
import AccessWrapper, { USER_ROLES } from 'apps/AccessWrapper'
import AuthPage from 'apps/AuthPage'
import Text from 'elements/Text'
import * as styles from './NoAvailablePrinterForm.scss'

interface IProps {
  t: TextType,
  onGoToChangeSubscription: () => void,
  onAddToWaitlist: () => void,
}

const NoAvailablePrinterForm: React.FC<IProps> = ({ t, onGoToChangeSubscription, onAddToWaitlist }) => (
  <AuthPage>
    <div className={styles.root}>
      <Text>{t('message')}</Text>
      <AccessWrapper on={[USER_ROLES.subscriptionUser]}>
        <Text styleType='largeIndent'>
          <a href='#' onClick={onGoToChangeSubscription}>{t('hereLink')}</a> {t('changeSubscription')}
        </Text>
      </AccessWrapper>
      <Text styleType='largeIndent'>
        <a href='#' onClick={onAddToWaitlist}>{t('hereLink')}</a> {t('addToWaitlist')}
      </Text>
    </div>
  </AuthPage>
)

export default NoAvailablePrinterForm
